import { EnvelopeAllovedActions } from '@const/consts';
import { IEnvelope } from '@store/modules/envelopes/types';

export const ENVELOPE_MASS_ACTIONS = [
  EnvelopeAllovedActions.SIGN,
  EnvelopeAllovedActions.APPROVE,
  EnvelopeAllovedActions.DECLINE_SIGN,
  EnvelopeAllovedActions.DECLINE_APPROVE,
  EnvelopeAllovedActions.STOP_PROCESS,
];

export const getEnvelopeMassActionAvailability = (
  envelopes: Array<Pick<IEnvelope, 'allowedMassActions'>>
): Record<EnvelopeAllovedActions, boolean> => ENVELOPE_MASS_ACTIONS.reduce(
  (availability, action) => ({
    ...availability,
    [action]: envelopes.some((envelope) => envelope.allowedMassActions?.includes(action)),
  }),
  {} as Record<EnvelopeAllovedActions, boolean>
);
